export class Celebrity {

    message : string;  
    celebname : string;  
    celebcode :String;
    status :String;
    id : number;
}
